const SvgChevronDown = () => (
	<svg width="1em" height="1em" viewBox="0 0 14 9" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
		<path d="m7 7 .707.707L7 8.414l-.707-.707L7 7Zm6.707-5.293-6 6-1.414-1.414 6-6 1.414 1.414Zm-7.414 6-6-6L1.707.293l6 6-1.414 1.414Z" />
	</svg>
)

export default SvgChevronDown
